
import moment from "moment-timezone";
import "moment/locale/pt-br"
import md5 from "crypto-js/md5"

moment.locale("moment/locale/pt-br");
moment.tz.setDefault("America/Bahia")


export const getUtc = (inp:any) => {
    return moment.utc(inp);
}

export const errorToString = (error:any) => {
    if(typeof error === "object"){
        return JSON.stringify(error);
    }
    return String(error);
}

export const validateJson = (json:object) => {
    try {
        var jsonStrinfy = JSON.stringify(json);
        return JSON.parse(jsonStrinfy);
    } catch (error) {
        throw new Error("Estrutura Json invalida. "+errorToString(error))
    }
    
}


export const formatMoney = (value: number,style?:"currency"| "decimal" | "percent" | "unit") => {
    if (!value) return style === "currency" ? "R$ 0,00" : "0,00";
    const formatter = new Intl.NumberFormat('pt-BR', {
        style: style || 'currency',
        minimumFractionDigits: 2,
        currency: 'BRL'
    });
    let formated = formatter.format(value);
    return formated;
};

export const getImg = (row:any,fieldDescription:string) => {
    if(!isEmpty(row)){
        if(!isEmpty(row._attachments)){
            var imgList:any[] = []
            for (const key in row._attachments) {
                let el = row._attachments[key]
                imgList.push(el);          
            }            
            let url = "";
            try {
                if(imgList.length > 0){
                    url = URL.createObjectURL(imgList[0].data)
                }
                return url                    
            } catch (error) {
                console.log("Erro no getImg do item "+JSON.stringify(row)+ "detalhes: "+error)
                return "";
            }
        } else {
            return row[fieldDescription];
        }    
    } else {
        return ""
    }
}

export const isEmailValid = (email: string) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
};

export const onlyNumber = (value: any) => {
    let str = String(value);
    var numsStr = str.replace(/[^0-9]/g, '');
    console.log("onlyNumber", numsStr);
    return parseInt(numsStr);
}

export const soma = (array: any[], rowQt: any, rowValue: any) => {
    var total = 0;
    //console.log(array);
    array.map((row, key) => {
        if (rowQt != '') {
            var valor = row[rowQt] * row[rowValue];
            total = total + valor;
        } else {
            //console.log(row[rowValue]);
            total = total + row[rowValue];
        }
    });
    return Number(total.toFixed(2));
}

export const cpfValid = (cpf: string) => {
    // Validar se é String
    if (typeof cpf !== 'string') return false

    // Tirar formatação
    cpf = cpf.replace(/[^\d]+/g, '')

    // Validar se tem tamanho 11 ou se é uma sequência de digitos repetidos
    if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) return false

    // String para Array
    var cpfArr = cpf.split('')

    const validator = cpfArr
        // Pegar os últimos 2 digitos de validação
        .filter((digit, index, array) => index >= array.length - 2 && digit)
        // Transformar digitos em números
        .map(el => +el)

    const toValidate = (pop: number) => cpfArr
        // Pegar Array de items para validar
        .filter((digit, index, array) => index < array.length - pop && digit)
        // Transformar digitos em números
        .map(el => +el)

    const rest = (count: number, pop: number) => (toValidate(pop)
        // Calcular Soma dos digitos e multiplicar por 10
        .reduce((soma, el, i) => soma + el * (count - i), 0) * 10)
        // Pegar o resto por 11
        % 11
        // transformar de 10 para 0
        % 10

    return !(rest(10, 2) !== validator[0] || rest(11, 1) !== validator[1])
}

export const getTokenBasicAuth = (user: string, pass: string) => {
    let token = btoa(user + ":" + pass);
    return token;
}

export const excluirRegistroArray = (array: any[], index: number) => {
    array.splice(index, 1);
}

export const excluirRegistroArrayRow = (array: any[], row: any) => {
    let i = array.findIndex(find => find._id === row._id);
    array.splice(i, 1);
}

export const findIndexRegistroArray = (array: any[], row: any) => {
    let i = array.findIndex(find => find._id === row._id);
    return i
}

export const formatDateIsoValue = (date?: string) => {
    let d = moment(date).format();
    return d;
}

export const getDataText = (date: string) => {
    let d = moment(date).format("DD/MM/YYYY");
    return d;
}

export const formatData = (date: string) => {
    let d = moment(date).format("DD/MM/YYYY HH:mm");
    return d;
}

export const getDataAmerica = (date?: string) => {
    return moment(date).format("YYYY-MM-DD");
}

export const formatDataAteAgora = (date: string) => {
    return moment(date).fromNow();
}
/* 
retorna ex: hoje as 8:00
 */
export const formatDataCalendar = (date:string) => {
    return moment(date).subtract('days').calendar();
}

export const isEmpty = (prm: any) => {
    if (typeof prm === "object") {
        return Object.keys(prm).length === 0
    } else {
        switch (prm) {
            case null:
                return true;
            case undefined:
                return true;
            case '':
                return true
            default:
                return false
        }
    }
}

export const getNewId = (idx?:number) => {
    const dt = new Date();
    let sufix = idx?idx:Math.floor( Math.random() * 100)
    let idN = dt.getDate() + dt.getTime() + dt.getSeconds() + dt.getMilliseconds() + sufix;
    let random = Math.floor( Math.random() * 100);
    //let idS = this.getHashSha256(idN);
    return idN.toString() +"-"+random.toString();
}

export const cryptoMd5 = (value: string) => {
    return md5(value).toString();
}

/* 
*@object é o obejeto a ser verificado se existe a propriedade
*@propertName contem um array de string que são as proprieddades a serem verificadas no mesmo nível
* exemplo: objeto.nome.id propertName deve ser parametrizado assim ['nome','id']
* o codigo vai verificar se o objeto no primeiro paramentro tem a propriedade nome
* e de se o objeto nome tem a propriedade id 
*/
export const existePropriedade = (object: Object, propertName: Array<string>) => {

    let resultado = false;
    //validar objeto
    if (typeof object === "object") {
        //recebe o objeto pai para iniciar o ciclo
        let objChild: any = object;
        for (let i = 0; i < propertName.length; i++) {
            const element = propertName[i];
            //verificar existe a propriedade
            if (objChild.hasOwnProperty(element)) {
                //se existir verificar se é um objeto
                if (typeof objChild[element] === 'object') {
                    //preencher com o novo objeto
                    objChild = objChild[element];
                    resultado = true;
                } else {
                    resultado = true;
                }
            } else {
                resultado = false;
                break;//nao tem a propriedade
            }
        }

    }
    return resultado;
}

/* 
    @atualizarPropriedadesDocsArray 
    funçao para atualizar as propriedades dos objetos em uma lista 
    @var1 array com os documentos a ser atualizados
    @var2 objeto modelo para ser verificado
*/
export const atualizarPropriedadesDocsArray = (var1: Array<any>, var2: any) => {
    try {
        // Função auxiliar para verificar e incluir propriedades de objetos
        const verificarEIncluirPropriedades = (objetoDestino: any, objetoOrigem: any) => {
            for (const propriedade in objetoOrigem) {
                if (objetoOrigem.hasOwnProperty(propriedade)) {
                    // Se a propriedade é um objeto, chama recursivamente a função
                    if (typeof objetoOrigem[propriedade] === 'object' && objetoOrigem[propriedade] !== null) {
                        objetoDestino[propriedade] = objetoDestino[propriedade] || {};
                        verificarEIncluirPropriedades(objetoDestino[propriedade], objetoOrigem[propriedade]);
                    } else {
                        // Se não for um objeto, verifica e inclui a propriedade
                        if (!(propriedade in objetoDestino)) {
                            objetoDestino[propriedade] = objetoOrigem[propriedade];
                        }
                    }
                }
            }
        }

        // Loop através de cada objeto no array
        for (let i = 0; i < var1.length; i++) {
            const objetoAtual = var1[i];

            // Verifica se todas as propriedades de var2 estão presentes no objeto atual
            for (const propriedadeVar2 in var2) {
                if (var2.hasOwnProperty(propriedadeVar2)) {
                    // Se a propriedade é um objeto, chama a função auxiliar
                    if (typeof var2[propriedadeVar2] === 'object' && var2[propriedadeVar2] !== null) {
                        objetoAtual[propriedadeVar2] = objetoAtual[propriedadeVar2] || {};
                        verificarEIncluirPropriedades(objetoAtual[propriedadeVar2], var2[propriedadeVar2]);
                    } else {
                        // Se não for um objeto, verifica e inclui a propriedade
                        if (!(propriedadeVar2 in objetoAtual)) {
                            objetoAtual[propriedadeVar2] = var2[propriedadeVar2];
                        }
                    }
                }
            }
        }

        // Retorna o array atualizado
        return var1;

    } catch (error) {
        console.log(error)
    }
}


export const calcMargem = (entrada: "%" | "$", valor: number, custo: number) => {
    //se os valores não estiverm, retorna 0
    if (valor <= 0 || custo <= 0 || !valor || !custo) return 0;

    if (entrada === "%") {
        //entrada com a margem percentual o retorno é o preço
        //formula= (custo * valor / 100) + custo

        let result = (custo * valor) / 100 + custo;
        //setFieldPreco(Number(result.toFixed(2)));
        return Number(result.toFixed(2));
    } else {
        //entrada como preço o retorno é a margem percentual
        //formula = ( (valor - custo) / custo * 100 )
        let result = ((valor - custo) / custo) * 100;
        //setFieldMargem(Number(result.toFixed(2)))
        return Number(result.toFixed(2));
    }
};


export const getKeyValue = (obj: Object, searchKey: string) => {
    let arr = searchKey.split('.');
    let result = "";
    if (typeof obj === "object") {
        //recebe o objeto pai para iniciar o ciclo
        let objChild: any = obj;
        for (let i = 0; i < arr.length; i++) {
            const element = arr[i];
            //verificar existe a propriedade
            if (objChild.hasOwnProperty(element)) {
                //se existir veriricar se é um objeto
                if (typeof objChild[element] === 'object') {
                    //preencher com o novo objeto
                    objChild = objChild[element];
                } else {
                    result = objChild[element];
                }
            }
        }
    }
    return result;
}


export const setValueKey = (obj: Object, searchKey: string, value: any) => {
    let arr = searchKey.split('.');
    let objChild: any;
    if (typeof obj === "object") {
        //recebe o objeto pai para iniciar o ciclo
        objChild = obj;
        for (let i = 0; i < arr.length; i++) {
            const element = arr[i];
            //verificar existe a propriedade
            if (objChild.hasOwnProperty(element)) {
                //se existir veriricar se é um objeto
                if (typeof objChild[element] === 'object') {
                    //preencher com o novo objeto
                    objChild = objChild[element];
                } else {
                    objChild[element] = value;
                }
            }
        }
    }
    return objChild;
}

export const playSong = (songDir: string) => {
    var song = new Audio(songDir);
    song.play();
}


export const mutatorSetValue = ([field, value]: any, state: any, { changeValue }: any) => {
    changeValue(state, field, () => value)
}

export const SimulateDotPress = () => {
    window.addEventListener('keydown', (e) => {
        if (e.keyCode === 110) {
            window.dispatchEvent(new KeyboardEvent('keydown', {
                keyCode: 118,
            }));
        }
    })

}

export enum displayBreakpointsValues { sx = 0, sm = 1, md = 2, lg = 3, xl = 4 };
export const displayBreakpoints = (width: number) => {
    if (width >= 0 && width < 599) {
        return displayBreakpointsValues.sx;//extra-small 0px
    } else if (width >= 600 && width < 899) {
        return displayBreakpointsValues.sm;// small: 600px
    } else if (width >= 900 && width < 1199) {
        return displayBreakpointsValues.md;//medium: 900px
    } else if (width >= 1200 && width < 1535) {
        return displayBreakpointsValues.lg;//large: 1200px
    } else {
        return displayBreakpointsValues.xl;//extra-large: 1536px
    }
}

interface ListOptDataTextProps {
    label: string;
    value: { dtIni: string, dtFim: string }
}
export const listDataText = () => {
    let objData = new Date();
    const objDataFix = new Date();
    objDataFix.setHours(23,59,59);
    objData.setHours(0, 0, 0);
    const listOptDataText: ListOptDataTextProps[] = [];

    let hoje: ListOptDataTextProps = {
        label: "Hoje", value: { dtIni: objData.toISOString(), dtFim: objDataFix.toISOString() }
    };
    listOptDataText.push({...hoje});

    /**SET DATA SEMANA ATUAL  1*/
    let diaHoje = objData.getDay();//0 domingo
    let dataHoje = objData.getDate();
    let dataIniSemana = dataHoje - diaHoje;
    objData.setDate(dataIniSemana);
    let semanaAtual: ListOptDataTextProps = {
        label: "Semana Atual",
        value: { dtIni: objData.toISOString(), dtFim: objDataFix.toISOString() }
    };
    listOptDataText.push({...semanaAtual});

    /**SET DATA SEMANA PASSADA  2*/
    let dataIniSemPassada = (objData.getDate() - 7);
    objData.setDate(dataIniSemPassada);
    let objDataFim = new Date(objData.toISOString());
    objDataFim.setDate(dataIniSemPassada + 6);//ir para o final da semana passada
    objDataFim.setHours(23,59,59);
    let semanaPassada: ListOptDataTextProps = {
        label: "Semana Passada",
        value: { dtIni: objData.toISOString(), dtFim: objDataFim.toISOString() }
    }
    listOptDataText.push({...semanaPassada});

    /**SET DATA MES ATUAL 3*/
    objData = new Date();//voltar para a data atual;
    objData.setDate(1);// setar o primeiro dia do mes
    objData.setHours(0,0,0)
    let mesAtual: ListOptDataTextProps = {
        label: "Mês Atual",
        value: { dtIni: objData.toISOString(), dtFim: objDataFix.toISOString() }
    }
    listOptDataText.push({...mesAtual});

    /**SET DATA MES PASSADO 4*/
    objData.setDate(objDataFix.getDate());//voltar para a data atual;
    objData.setDate(0);//seta para o ultimo dia do mes anterior
    objDataFim = new Date(objData.toISOString());
    objData.setDate(1);//seta para o primeiro dia do mes anterior
    let mesPassado: ListOptDataTextProps = {
        label: "Mês Passado",
        value: { dtIni: objData.toISOString(), dtFim: objDataFim.toISOString() }
    }
    listOptDataText.push({...mesPassado});

    /**Personalizado 4*/
    objData = new Date();//voltar para a data atual;
    objData.setDate(1);//seta para o primeiro dia do mes atual
    objData.setHours(0, 0, 0);
    let objDataFimPerson = new Date();
    objDataFimPerson.setHours(23,59,59);
    let personalizado: ListOptDataTextProps = {
        label: "Definir data",
        value: { dtIni: objData.toISOString(), dtFim: objDataFimPerson.toISOString() }
    }
    listOptDataText.push({...personalizado});

    return listOptDataText
}

